import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { Excel, TrayArrowUp } from '@opengov/react-capital-assets';
import React from 'react';
import locale from './customReports-locale.json';
import { styles } from './CustomReportsEmptyState.styles';

type Props = {
  onUploadButtonClick: () => void;
};

export function CustomReportsEmptyState({ onUploadButtonClick }: Props) {
  return (
    <Box sx={styles.container} data-test="custom-reports-empty-state">
      <Box sx={styles.iconContainer}>
        <SvgIcon component={Excel} inheritViewBox sx={styles.icon} />
      </Box>

      <Typography variant="h3" sx={styles.title}>
        {locale.emptyState.title}
      </Typography>

      <Typography variant="body1" sx={styles.description}>
        {locale.emptyState.description}
      </Typography>

      <Button variant="outlined" startIcon={<TrayArrowUp />} onClick={onUploadButtonClick}>
        {locale.emptyState.uploadButton}
      </Button>
    </Box>
  );
}
